import http from '../helpers/http';

export default class VirtualCardRepository {
    lookupCardByVirtualQr(virtualQrCode) {
        return http.post('/api/v1/virtualcards/lookup', { qrCode: virtualQrCode });
    }
}